/* eslint-disable no-useless-return */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './css/TouristsPopover.css';
import {
  ADULTS,
  ADULTS_FROM,
  ADD_KID,
  BEFORE_YEAR,
  ONE_YEAR,
  TWO_YEARS,
  THREE_YEARS,
  FOUR_YEARS,
  FIVE_YEARS,
  SIX_YEARS,
  SEVEN_YEARS,
  EIGHT_YEARS,
  NINE_YEARS,
  TEN_YEARS,
  ELEVEN_YEARS,
  TWELVE_YEARS,
  THIRTEEN_YEARS,
  FOURTEEN_YEARS,
  FIFTEEN_YEARS,
  SIXTEEN_YEARS,
  SEVENTEEN_YEARS,
  KIDS_AGE_NOTE,
} from '../../../Utils/Constants/HomePageConstants';
import { getKidsText } from '../../../Utils/CommonUtils';
import {
  increaseAdults,
  decreaseAdults,
  setKids,
} from '../../../DataStore/actions/searchFormActions';

import { ReactComponent as PlusIco } from '../../../images/search-form-plus.svg';
import { ReactComponent as MinusIco } from '../../../images/search-form-minus.svg';
import { ReactComponent as Arrow } from '../../../images/arrow-bottom-black-r.svg';
import { ReactComponent as Cross } from '../../../images/gray-cross-r.svg';

const mapStateToProps = (state) => ({ ...state });

class TouristsPopover extends React.Component {
  constructor(props) {
    const { kids } = props;
    super();
    this.state = {
      kidsAgeSelectorVisible: false,
      isAddKidsButtonVisible: kids.length < 3,
    };
  }

  changeKidsAgeSelectorVisibility = () => {
    const { kidsAgeSelectorVisible } = this.state;

    if (kidsAgeSelectorVisible) {
      document.removeEventListener('click', this.handleOutsideClick, false);
    } else {
      document.addEventListener('click', this.handleOutsideClick, false);
    }

    this.setState({ kidsAgeSelectorVisible: !kidsAgeSelectorVisible });
  };

  handleOutsideClick = (e) => {
    if (
      (this.node && this.node.contains(e.target)) ||
      (this.buttonNode && this.buttonNode.contains(e.target))
    ) {
      return;
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
      this.setState({ kidsAgeSelectorVisible: false });
    }
  };

  removeKid = (kid) => {
    const { kids, setKids: setKidsAction } = this.props;

    const res = kids.filter((kidItem) => kidItem.index !== kid.index);

    this.setState({ isAddKidsButtonVisible: true });

    setKidsAction(res);
  };

  renderKids = (kids) =>
    kids.map((kid, index) => (
      <div key={`form_kid_item-${index}`} className="sf_selected_kid_w">
        <div className="sf_selected_kid">
          <div className="bm_text_18">{kid.text}</div>
          <button
            onClick={() => this.removeKid(kid)}
            type="button"
            className="sf_tourists_cross_but"
          >
            <Cross className="sf_tourists_cross_ico" />
          </button>
        </div>
      </div>
    ));

  hadleKidClick = (age) => {
    const { kids, setKids: setKidsAction } = this.props;

    const kid = { age, text: getKidsText(age), index: kids.length };

    const result = kids.concat([kid]);
    setKidsAction(result);

    if (result.length === 3) {
      this.setState({
        isAddKidsButtonVisible: false,
        kidsAgeSelectorVisible: false,
      });
      document.removeEventListener('click', this.handleOutsideClick, false);
    }
  };

  render() {
    const {
      adults,
      increaseAdults: increaseAdultsAction,
      decreaseAdults: decreaseAdultsAction,
      kids,
    } = this.props;

    const { kidsAgeSelectorVisible, isAddKidsButtonVisible } = this.state;

    return (
      <div className="sf_tourists_w">
        <div className="sf_tourists_content">
          <div>
            <div className="bm_text_18 mb_2">{ADULTS}</div>
            <div className="gr_text_14">{ADULTS_FROM}</div>
          </div>
          <div className="sf_tourists_adults_w">
            <button
              type="button"
              className="sf_tourists_adults_ico"
              onClick={() => {
                decreaseAdultsAction();
              }}
            >
              <MinusIco />
            </button>
            <div className="bm_text_18 sf_tourists_adults">{adults}</div>
            <button
              type="button"
              className="sf_tourists_adults_ico"
              onClick={() => {
                increaseAdultsAction();
              }}
            >
              <PlusIco />
            </button>
          </div>
        </div>
        <div>{this.renderKids(kids)}</div>
        {isAddKidsButtonVisible && (
          <div className="sf_tourist_add_button_w">
            <button
              ref={(node) => {
                this.buttonNode = node;
              }}
              type="button"
              className="sf_tourist_add_button"
              onClick={() => this.changeKidsAgeSelectorVisibility()}
            >
              <div className="bm_text_16">{ADD_KID}</div>
              <Arrow
                className={`${kidsAgeSelectorVisible ? 'sf_tours_add_arrow_rotate' : ''}`}
              />
            </button>
          </div>
        )}
        <div
          ref={(node) => {
            this.node = node;
          }}
          className={`${kidsAgeSelectorVisible ? '' : 'sf_tourist_inv'}`}
        >
          <div className="sf_tourist_kinds_options_w">
            <div className="sf_tourist_kids_age_note gr_text_14">
              {KIDS_AGE_NOTE}
            </div>
            <div className="sf_tourist_kinds_options custom_scroll_container">
              <button
                type="button"
                className="br_text_16 sf_tourist_kids_item_buttom"
                onClick={() => {
                  this.hadleKidClick(0);
                }}
              >
                {BEFORE_YEAR}
              </button>
              <button
                type="button"
                className="br_text_16 sf_tourist_kids_item_buttom"
                onClick={() => {
                  this.hadleKidClick(1);
                }}
              >
                {ONE_YEAR}
              </button>
              <button
                type="button"
                className="br_text_16 sf_tourist_kids_item_buttom"
                onClick={() => {
                  this.hadleKidClick(2);
                }}
              >
                {TWO_YEARS}
              </button>
              <button
                type="button"
                className="br_text_16 sf_tourist_kids_item_buttom"
                onClick={() => {
                  this.hadleKidClick(3);
                }}
              >
                {THREE_YEARS}
              </button>
              <button
                type="button"
                className="br_text_16 sf_tourist_kids_item_buttom"
                onClick={() => {
                  this.hadleKidClick(4);
                }}
              >
                {FOUR_YEARS}
              </button>
              <button
                type="button"
                className="br_text_16 sf_tourist_kids_item_buttom"
                onClick={() => {
                  this.hadleKidClick(5);
                }}
              >
                {FIVE_YEARS}
              </button>
              <button
                type="button"
                className="br_text_16 sf_tourist_kids_item_buttom"
                onClick={() => {
                  this.hadleKidClick(6);
                }}
              >
                {SIX_YEARS}
              </button>
              <button
                type="button"
                className="br_text_16 sf_tourist_kids_item_buttom"
                onClick={() => {
                  this.hadleKidClick(7);
                }}
              >
                {SEVEN_YEARS}
              </button>
              <button
                type="button"
                className="br_text_16 sf_tourist_kids_item_buttom"
                onClick={() => {
                  this.hadleKidClick(8);
                }}
              >
                {EIGHT_YEARS}
              </button>
              <button
                type="button"
                className="br_text_16 sf_tourist_kids_item_buttom"
                onClick={() => {
                  this.hadleKidClick(9);
                }}
              >
                {NINE_YEARS}
              </button>
              <button
                type="button"
                className="br_text_16 sf_tourist_kids_item_buttom"
                onClick={() => {
                  this.hadleKidClick(10);
                }}
              >
                {TEN_YEARS}
              </button>
              <button
                type="button"
                className="br_text_16 sf_tourist_kids_item_buttom"
                onClick={() => {
                  this.hadleKidClick(11);
                }}
              >
                {ELEVEN_YEARS}
              </button>
              <button
                type="button"
                className="br_text_16 sf_tourist_kids_item_buttom"
                onClick={() => {
                  this.hadleKidClick(12);
                }}
              >
                {TWELVE_YEARS}
              </button>
              <button
                type="button"
                className="br_text_16 sf_tourist_kids_item_buttom"
                onClick={() => {
                  this.hadleKidClick(13);
                }}
              >
                {THIRTEEN_YEARS}
              </button>
              <button
                type="button"
                className="br_text_16 sf_tourist_kids_item_buttom"
                onClick={() => {
                  this.hadleKidClick(14);
                }}
              >
                {FOURTEEN_YEARS}
              </button>
              <button
                type="button"
                className="br_text_16 sf_tourist_kids_item_buttom"
                onClick={() => {
                  this.hadleKidClick(15);
                }}
              >
                {FIFTEEN_YEARS}
              </button>
              <button
                type="button"
                className="br_text_16 sf_tourist_kids_item_buttom"
                onClick={() => {
                  this.hadleKidClick(16);
                }}
              >
                {SIXTEEN_YEARS}
              </button>
              <button
                type="button"
                className="br_text_16 sf_tourist_kids_item_buttom"
                onClick={() => {
                  this.hadleKidClick(17);
                }}
              >
                {SEVENTEEN_YEARS}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TouristsPopover.propTypes = {
  adults: PropTypes.number.isRequired,
  kids: PropTypes.instanceOf(Array).isRequired,
  setKids: PropTypes.func.isRequired,
  increaseAdults: PropTypes.func.isRequired,
  decreaseAdults: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, {
  setKids,
  increaseAdults,
  decreaseAdults,
})(TouristsPopover);
